module.exports = __webpack_public_path__ + "img/nt106-00-81-1.asm.e9aa504a.jpg";